import axios from 'axios'

// import assert from 'assert'

import urlJoin from 'url-join'

let API_URL = process.env.VUE_APP_API_URL

function getAccessToken () {
  try {
    return JSON.parse(localStorage.getItem('store')).accessToken
  } catch (e) {
    return null
  }
}

function getData (url) {
  const accessToken = getAccessToken()
  if (accessToken) {
    let headers = {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    }

    return axios.get(urlJoin(API_URL, url, `?logStamp=${(new Date()).getTime()}`), { headers: headers })
      .then((response) => {
        return new Promise((resolve) => {
          resolve(response.data)
        })
      }).catch((err) => {
        console.error('err:', err)
      })
  } else {
    return axios.get(urlJoin(API_URL, url, `?logStamp=${(new Date()).getTime()}`))
      .then((response) => {
        return new Promise((resolve) => {
          resolve(response.data)
        })
      })
  }
}

function postData (url, json) {
  let headers = {
    'Content-Type': 'application/json'
  }

  const accessToken = getAccessToken()
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  return axios.post(urlJoin(API_URL, url, `?logStamp=${(new Date()).getTime()}`), json, { headers: headers })
    .then((response) => {
      return new Promise((resolve) => {
        resolve(response.data)
      })
    })
}

export {
  getData, postData
}
